import React, { useRef, useEffect } from "react";
import useFadeIn from "../hooks/useFadeIn";
import "../styles/EducationStyle.css";
import "../styles/GlobalStyles.css";

const licensingCurriculum = [
  "Eye structure",
  "Function and disorders of the eye and orbital areas",
  "Eyelash growth cycles",
  "Contraindications and allergic reactions",
  "Infection control",
  "Eye shapes and eyelash evaluation",
  "Product ingredients and retention",
  "Health and Safety",
  "Board statutes and rules",
  "Client consultation",
  "Custom lash design",
  "Cleansing the eye area",
  "Applying eyelash extensions",
  "Removing eyelash extensions",
  "Social media, pricing, and business basics",
  "Hours of hands-on practice and instruction",
  "Building your clientele",
  "Scripts and templates",
  "Angel lashes, advanced fan making",
  "Free copy of my 'I got licensed now what..?' business manual"
];

const masteryCurriculum = [
  "Eye shapes and eyelash evaluation",
  "Product ingredients and retention",
  "Contraindications and allergic reactions",
  "Lash fanning techniques including 'Quick Fans' and pinching",
  "Client consultation forms",
  "Custom lash design and mapping",
  "Cleansing the eye area",
  "Different attachment techniques",
  "Removing eyelash extensions",
  "Social media, pricing, and business module",
  "Hands-on practice with a live model",
  "Includes my 'I got licensed... now what?' E-book on how to start a business",
  "Building your clientele 101",
  "How to raise prices",
  "Getting AMAZING retention",
  "Tackle any lash struggles",
  "Become fully booked",
  "Scripts and templates"
];

const Education = () => {
  const refHeader1 = useFadeIn();
  const refWho = useFadeIn();
  const refTeach1 = useFadeIn();
  const refHeader2 = useFadeIn();
  const refTeach2 = useFadeIn();
  const refEnroll2 = useFadeIn();
  const heroSentinel = useRef(null);
  const stickyRef = useRef(null);
  const masterySentinel = useRef(null);
  const stickyRef2 = useRef(null);

  useEffect(() => {
    const licensingSticky = stickyRef.current;
    const masterySticky = stickyRef2.current;
    const heroEnd = heroSentinel.current;
    const masteryStart = masterySentinel.current;
    if (!licensingSticky || !masterySticky || !heroEnd || !masteryStart) return;

    const update = () => {
      const navH = 62;
      const heroBottom = heroEnd.getBoundingClientRect().top;
      const masteryTop = masteryStart.getBoundingClientRect().top;

      const pastHero = heroBottom <= navH;
      const pastMastery = masteryTop <= navH;

      if (pastMastery) {
        licensingSticky.classList.remove("visible");
        masterySticky.classList.add("visible");
      } else if (pastHero) {
        licensingSticky.classList.add("visible");
        masterySticky.classList.remove("visible");
      } else {
        licensingSticky.classList.remove("visible");
        masterySticky.classList.remove("visible");
      }
    };

    window.addEventListener("scroll", update, { passive: true });
    update();
    return () => window.removeEventListener("scroll", update);
  }, []);

  return (
    <div className="education-page">
      {/* Sticky title bar — Licensing */}
      <div ref={stickyRef} className="edu-sticky-title">
        <span className="edu-sticky-title__dot" />
        Lash Licensing Course
      </div>
      {/* Sticky title bar — Mastery */}
      <div
        ref={stickyRef2}
        className="edu-sticky-title edu-sticky-title--mastery"
      >
        <span className="edu-sticky-title__dot" />
        Lash Mastery Course
      </div>
      {/* ── Hero banner: Licensing Course ── */}
      <div ref={refHeader1} className="edu-hero fade-up">
        <span className="edu-hero__eyebrow">Arizona Board Approved</span>
        <h1>Lash Licensing Course</h1>
        <p className="edu-hero__desc">
          The lash course of your dreams. A 4-day, 30-hour training program
          approved by the Arizona State Board of Cosmetology. You'll earn an
          official lash extension technician license, receive a Light Heart
          luxury lash kit, and leave fully equipped for the real lash world.
        </p>
        <p className="edu-hero__desc">
          <strong>2 days in person · 2 days online</strong> — private 1-on-1 or
          2-on-1 sessions.
        </p>
        <div className="edu-hero__chips">
          <span className="edu-hero__chip">30 Hours</span>
          <span className="edu-hero__chip">Luxury Lash Kit Included</span>
          <span className="edu-hero__chip">State Licensed</span>
          <span className="edu-hero__chip">1-on-1 Available</span>
        </div>
      </div>
      {/* Sentinel: triggers sticky bar when hero leaves viewport */}
      <div ref={heroSentinel} style={{ height: 0 }} />

      <section
        ref={refWho}
        className="who-can-sign-up fade-up"
        style={{ marginTop: "32px" }}
      >
        <h2>WHO CAN SIGN UP</h2>
        <p>
          Great news!! In the state of Arizona you no longer need to be a
          licensed esthetician to perform lash extensions. Anyone is able to
          sign up who has:
        </p>
        <ul>
          <li>Proof of at least two years of high school education</li>
          <li>Proof of citizenship / legal residency</li>
        </ul>
      </section>

      <section ref={refTeach1} className="what-i-teach fade-up">
        <ul>
          {licensingCurriculum.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      </section>

      {/* Divider image between courses */}
      <div
        style={{
          maxWidth: "840px",
          margin: "8px auto 40px",
          padding: "0 18px"
        }}
      >
        <div
          style={{
            position: "relative",
            borderRadius: "var(--radius-lg, 20px)",
            overflow: "hidden",
            boxShadow: "var(--shadow-lg)"
          }}
        >
          <img
            src="/courteducation.jpg"
            alt="Courtney teaching"
            style={{ width: "100%", display: "block" }}
          />
          <div
            style={{
              position: "absolute",
              inset: 0,
              background:
                "linear-gradient(to bottom, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.15) 50%, transparent 100%)"
            }}
          />
          <div
            style={{
              position: "absolute",
              top: "24px",
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              width: "calc(100% - 48px)"
            }}
          >
            <a
              href="https://docs.google.com/forms/d/e/1FAIpQLSfbGVqEmojSveMbCgGQcOyDLTG1Q0Wv5lYt2cbajD5S2V_XnA/viewform?usp=header"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary btn-full"
            >
              Inquire About the Licensing Course
            </a>
          </div>
        </div>
      </div>

      {/* Sentinel for mastery */}
      <div ref={masterySentinel} style={{ height: 0 }} />

      <div className="mastery-block">
        {/* ── Hero banner: Mastery Course ── */}
        <div ref={refHeader2} className="edu-hero edu-hero--mastery fade-up">
          <span className="edu-hero__eyebrow">For Licensed Lash Artists</span>
          <h1>Lash Mastery Course</h1>
          <p className="edu-hero__desc">
            This in person 8-hour Lash Mastery Course is for licensed lash
            artists looking to take their skills to the next level. I'll walk
            you through all my tips and tricks for creating flawless lash sets,
            mastering eye mapping, and perfecting advanced techniques. We'll
            dive deep into the "why" behind every step, and I'll help you
            overcome any struggles in your lash career.
          </p>
          <p className="edu-hero__desc">
            After completing this course, your business will grow, and you'll
            have the skills to become a fully booked lash artist with luxury
            pricing.
          </p>
          <span className="edu-hero__desc">
            You must be a licensed lash artist or esthetician to take this
            course.
          </span>
          <div className="edu-hero__chips">
            <span className="edu-hero__chip">8 Hours In-Person</span>
            <span className="edu-hero__chip">Live Model Included</span>
            <span className="edu-hero__chip">E-Book Included</span>
            <span className="edu-hero__chip">Licensed Artists Only</span>
          </div>
        </div>

        <section
          ref={refTeach2}
          className="what-i-teach fade-up"
          style={{ marginTop: "32px" }}
        >
          <ul>
            {masteryCurriculum.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </section>

        <section ref={refEnroll2} className="extras fade-up">
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSfIF1IeQ4dgONnHsZi4YYSC01PQic4DVqFwM_b1zVv0eC_tvg/viewform?usp=header"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-mastery"
          >
            Inquire About the Mastery Course
          </a>
        </section>
      </div>
    </div>
  );
};

export default Education;
